const carouselItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20breaking%20news%20headline%20on%20black%20background%20with%20neon%20green%20glowing%20text%20accents%2C%20tabloid%20magazine%20cover%20style%2C%20sensational%20gossip%20aesthetic%2C%20high%20contrast%2C%20editorial%20photography&width=800&height=500&seq=carousel-01-scandal&orientation=landscape',
    tag: '独家深挖',
    title: '顶流男星私生活全纪录：你不知道的另一面',
    desc: '从出道到如今的每一个争议瞬间，我们用时间线为你还原最真实的娱乐圈生态。',
    reads: '5.8万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20expose%20and%20whistleblower%20theme%20on%20dark%20background%20with%20acid%20green%20highlights%2C%20secret%20document%20leak%20aesthetic%2C%20mysterious%20atmosphere%2C%20minimal%20composition&width=800&height=500&seq=carousel-02-expose&orientation=landscape',
    tag: '黑料曝光',
    title: '资本操控娱乐圈：背后的财团与利益链全揭秘',
    desc: '深度调查各大娱乐公司背后的资本结构，为你拆解造星工厂的运作模式。',
    reads: '4.2万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20reality%20show%20drama%20theme%20on%20dark%20background%20with%20neon%20green%20glow%2C%20stage%20spotlight%20and%20conflict%20aesthetic%2C%20dramatic%20tension%2C%20minimal%20yet%20bold&width=800&height=500&seq=carousel-03-variety&orientation=landscape',
    tag: '综艺内幕',
    title: '热门综艺节目背后的剧本争议与暗箱操作',
    desc: '多位退赛选手匿名爆料，还原综艺节目录制背后的真实游戏规则。',
    reads: '3.9万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20social%20media%20trend%20and%20viral%20content%20theme%20on%20dark%20background%20with%20neon%20green%20accents%2C%20digital%20wave%20and%20influence%20aesthetic%2C%20minimal%20modern%20composition&width=800&height=500&seq=carousel-04-trend&orientation=landscape',
    tag: '行业趋势',
    title: '2026网红经济大洗牌：谁在崛起谁在倒下',
    desc: '从流量数据到商业变现，全面解析当下网红生态的格局变化与未来走向。',
    reads: '3.1万',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="relative py-20 md:py-28 px-4 md:px-8 bg-background-100/50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-accent-500/10 text-accent-400 text-xs font-semibold rounded-full border border-accent-500/20 whitespace-nowrap mb-4">
            <i className="ri-focus-2-line text-[10px]"></i>
            焦点专题
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-foreground-50 tracking-tight">
            深度 <span className="font-heading italic text-accent-400">调查报道</span>
          </h2>
          <p className="text-foreground-400 text-sm mt-3 max-w-lg mx-auto">
            精选编辑团队深度采写的重磅专题，每一篇都是不可错过的吃瓜盛宴
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
          {carouselItems.map((item, i) => (
            <a
              key={i}
              href="#carousel"
              className="group relative rounded-2xl overflow-hidden bg-background-100 border border-background-200/50 aspect-[16/10] cursor-pointer"
            >
              <img
                src={item.image}
                alt={item.title}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/40 to-transparent"></div>
              <div className="absolute top-4 left-4">
                <span className="inline-flex px-2.5 py-1 bg-accent-500/90 text-background-950 text-[10px] font-bold rounded-full whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <h3 className="text-lg md:text-xl font-bold text-foreground-50 group-hover:text-accent-400 transition-colors mb-2 leading-snug">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-400 line-clamp-2 mb-3">{item.desc}</p>
                <span className="text-[11px] text-foreground-600 flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {item.reads} 阅读
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}